<script setup>
import {computed, ref} from "vue";
import SelectButton from "primevue/selectbutton";
import InputText from "primevue/inputtext";
import IconField from "primevue/iconfield";
import InputIcon from "primevue/inputicon";

const props = defineProps({
    isExpanded: Boolean,
    data: Array,
    currentId: Number,
    searchBy: {
        default: 'name',
        type: [String, Array]
    },
    defaultView: {
        default: 'list',
        type: String
    },
    disableViewChanging: Boolean
})

const view = ref(props.defaultView);
const views = [
    {
        key: 'grid',
        icon: 'pi pi-th-large'
    },
    {
        key: 'list',
        icon: 'pi pi-list'
    },
    /*{
        key: 'table',
        icon: 'pi pi-table'
    }*/
]

const search = ref('');

const computedData = computed(() => {
    if (search.value === '') {
        return props.data;
    }

    const searchFields = Array.isArray(props.searchBy) ? props.searchBy : [props.searchBy];
    const regex = new RegExp(`(${search.value.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&')})`, 'gi');

    return props.data.filter((item) => {
        return searchFields.some(field => {
            const value = item[field];
            if (typeof value === 'string') {
                return value.toLowerCase().includes(search.value.toLowerCase());
            } else if (Array.isArray(value)) {
                return value.some(el => typeof el === 'string' && el.toLowerCase().includes(search.value.toLowerCase()));
            }
            return false;
        });
    }).map((item) => {
        const newItem = {...item};
        searchFields.forEach(field => {
            const value = newItem[field];
            if (typeof value === 'string') {
                newItem[field] = value.replace(regex, '<em>$1</em>');
            } else if (Array.isArray(value)) {
                newItem[field] = value.map(el => {
                    if (typeof el === 'string') {
                        return el.replace(regex, '<em>$1</em>');
                    }
                    return el;
                });
            }
        });
        return newItem;
    });
})
</script>

<template>
    <div v-if="data.length" class="flex flex-col gap-4 pb-12">
        <div class="flex items-center justify-between">
            <IconField>
                <InputText v-model="search" class="!rounded-full" size="small"></InputText>
                <InputIcon class="pi pi-search" />
            </IconField>
            <SelectButton v-if="!disableViewChanging" v-model="view" :allow-empty="false" :options="views" option-value="key">
                <template #option="{option}">
                    <i :class="option.icon"></i>
                </template>
            </SelectButton>
            <slot name="heading"></slot>
        </div>
        <div>
            <template v-if="view === 'grid'">
                <TransitionGroup
                    tag="div"
                    name="grid-move"
                    class="grid gap-4 w-full"
                    :class="isExpanded ? 'grid-cols-1  2xl:grid-cols-2' : 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 '"
                >
                    <slot v-for="item in computedData" :key="item.id" name="grid-item" :selected="item.id === currentId"
                          :item="item"></slot>
                </TransitionGroup>
            </template>
            <template v-else-if="view === 'list'">
                <TransitionGroup
                    tag="div"
                    name="grid-move"
                    class="bg-white dark:bg-black dark:divide-neutral-700 dark:border-neutral-700 flex flex-col border rounded-3xl shadow-sm divide-y"
                >
                    <slot v-for="item in computedData" :key="item.id" name="list-item" :selected="item.id === currentId"
                          :item="item"></slot>
                </TransitionGroup>
            </template>
        </div>
    </div>
    <slot v-else name="empty"></slot>
</template>

<style scoped lang="scss">

</style>
